import { useEffect, useState } from "react";
import api from "../../lib/api";
import { PageHeader } from "../../components/common";
import { Card } from "../../components/ui/card";
import { Switch } from "../../components/ui/switch";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../../components/ui/tabs";
import Orders from "./shop/Orders";
import Products from "./shop/Products";
import Bank from "./shop/Bank";
import { toast } from "sonner";

export default function Shop() {
  const [f, setF] = useState(null);
  useEffect(() => { api.get("/site/features").then((r) => setF(r.data)); }, []);
  const toggle = async (v) => { const r = await api.put("/site/features", { shop_enabled: v }); setF(r.data); toast.success(v ? "Mağaza açıldı: menü, footer ve ana sayfada görünür" : "Mağaza kapatıldı: menü, footer ve ana sayfadan kalktı"); };
  return (
    <div className="space-y-6" data-testid="shop-page">
      <PageHeader eyebrow="Satış" title="Mağaza" subtitle="Ürünlerinizi ekleyin, müşteri adım adım havale ile satın alsın. Kapattığınızda site menüsü, footer ve ana sayfadan otomatik kalkar." />
      {f && <Card className="p-4 shadow-none border-slate-200 flex items-center gap-3">
        <Switch checked={f.shop_enabled} onCheckedChange={toggle} data-testid="shop-toggle" />
        <div><div className="font-semibold">{f.shop_enabled ? "Mağaza AÇIK" : "Mağaza KAPALI"}</div><div className="text-xs text-slate-500">Açıkken sitede <b>/magaza/</b> sayfası, menü ve footer bağlantısı ile ana sayfa kaydırıcısı görünür.</div></div>
      </Card>}
      <Tabs defaultValue="orders" urlTab>
        <TabsList><TabsTrigger value="orders" data-testid="stab-orders">Siparişler</TabsTrigger><TabsTrigger value="products" data-testid="stab-products">Ürünler</TabsTrigger><TabsTrigger value="bank" data-testid="stab-bank">Havale Bilgileri & Ayarlar</TabsTrigger></TabsList>
        <TabsContent value="orders" className="mt-4"><Orders /></TabsContent>
        <TabsContent value="products" className="mt-4"><Products /></TabsContent>
        <TabsContent value="bank" className="mt-4"><Bank /></TabsContent>
      </Tabs>
    </div>
  );
}
